import React, {useEffect, useState} from 'react'
import axios from 'axios'
import {Modal, ModalBody} from 'react-bootstrap'

import './HomePage.css'

import {BrandsItem} from '../../components/BrandsItem'
import {BannerHomeItem} from '../../components/BannerHomeItem'
import {BrandsHomeItem} from '../../components/homepage/BrandsHomeItem'
import {CategoriasItem} from '../../components/homepage/CategoriasItem'
import { MidBanner } from '../../components/homepage/MidBanner'
import { CatalogosHomeItem } from '../../components/homepage/CatalogosHomeItem'
import { EndbannerHomeItem } from '../../components/homepage/EndbannerHomeItem'

function HomePage() {
  // Altrego
  const [brands, setBrands] = useState('')
  const [bannersHome, setBannersHome] = useState('')
  const [brandsHome, setBrandsHome] = useState('')
  const [categorias, setCategorias] = useState('')
  const [catalogosHome, setCatalogosHome] = useState('')
  const [endbannersHome, setEndbannersHome] = useState('')

  // Brands
  const [showNewBrand, setShowNewBrand] = useState(false)
  const handleCloseNewBrand = () => setShowNewBrand(false)
  const handleShowNewBrand = () => setShowNewBrand(true)

  const [deleteBrandId, setDeleteBrandId] = useState('')
  const [showDeleteBrand, setShowDeleteBrand] = useState(false)
  const handleCloseDeleteBrand = () => setShowDeleteBrand(false)
  const handleShowDeleteBrand = (idElement) => {
    setShowDeleteBrand(true)
    setDeleteBrandId(idElement)
  }

  // Banner Home
  const [showNewBanner, setShowNewBanner] = useState(false)
  const handleCloseNewBanner = () => setShowNewBanner(false)
  const handleShowNewBanner = () => setShowNewBanner(true)

  const [deleteBannerHomeId, setDeleteBannerHomeId] = useState('')
  const [showDeleteBannerHome, setShowDeleteBannerHome] = useState(false)
  const handleCloseDeleteBannerHome = () => setShowDeleteBannerHome(false)
  const handleShowDeleteBannerHome = (idElement) => {
    setShowDeleteBannerHome(true)
    setDeleteBannerHomeId(idElement)
  }

  // Brands Home
  const [showNewBrandHome, setShowNewBrandHome] = useState('')
  const handleCloseNewBrandHome = () => setShowNewBrandHome(false)
  const handleShowNewBrandHome = () => setShowNewBrandHome(true)

  const [deleteBrandHomeId, setDeleteBrandHomeId] = useState('')
  const [showDeleteBrandHome, setShowDeleteBrandHome] = useState(false)
  const handleCloseDeleteBrandHome = () => setShowDeleteBrandHome(false)
  const handleShowDeleteBrandHome = (idElement) => {
    setShowDeleteBrandHome(true)
    setDeleteBrandHomeId(idElement)
  }

  // Categorias Home
  const [showNewCategoria, setShowNewCategoria] = useState('')
  const handleCloseNewCategoria = () => setShowNewCategoria(false)
  const handleShowNewCategoria = () => setShowNewCategoria(true)

  const [deleteCategoriaId, setDeleteCategoriaId] = useState('')
  const [showDeleteCategoria, setShowDeleteCategoria] = useState(false)
  const handleCloseDeleteCategoria = () => setShowDeleteCategoria(false)
  const handleShowDeleteCategoria = (idElement) => {
    setShowDeleteCategoria(true)
    setDeleteCategoriaId(idElement)
  }

    // Banner Home
  const [showNewEndbanner, setShowNewEndbanner] = useState(false)
  const handleCloseNewEndbanner = () => setShowNewEndbanner(false)
  const handleShowNewEndbanner = () => setShowNewEndbanner(true)

  const [deleteEndbannerHomeId, setDeleteEndbannerHomeId] = useState('')
  const [showDeleteEndbannerHome, setShowDeleteEndbannerHome] = useState(false)
  const handleCloseDeleteEndbannerHome = () => setShowDeleteEndbannerHome(false)
  const handleShowDeleteEndbannerHome = (idElement) => {
    setShowDeleteEndbannerHome(true)
    setDeleteEndbannerHomeId(idElement)
  }

  const API_URL = process.env.REACT_APP_API_URL

  const getBrandsData = () => {
    axios
      .get(API_URL + '/brands')
      .then((response) => {
        let brands = response.data.data
        setBrands(brands)
      })
      .catch((error) => console.error('Error: ' + error))
  }

  const uploadNewBrand = () => {
    const data = new FormData()

    if (document.getElementById('file-marcas-new').files.length !== 0) {
      for (let i = 0; i < document.getElementById('file-marcas-new').files.length; i++) {
        data.append('file[]', document.getElementById('file-marcas-new').files[i])
      }

      data.append('name', '')

      axios
        .post(API_URL + '/new-brand', data, {
          // receive two parameter endpoint url ,form data
        })
        .then(
          (res) => {
            // then print response status
            setBrands(res.data.data)
            handleCloseNewBrand()
          },
          (error) => {
            alert(error)
          }
        )
    } else {
      console.error('vacío')
    }
  }

  const deleteBrand = (idElement) => {
    const data = {
      name: idElement,
    }

    axios
      .post(API_URL + '/delete-brand', data, {
        // receive two parameter endpoint url ,form data
      })
      .then(
        (res) => {
          // then print response status
          setBrands(res.data.data)
          handleCloseDeleteBrand()
        },
        (error) => {
          alert(error)
        }
      )
  }

  const getBannersHomeData = () => {
    axios
      .get(API_URL + '/banners-home')
      .then((response) => {
        let bannersHome = response.data.data
        setBannersHome(bannersHome)
      })
      .catch((error) => console.error('Error: ' + error))
  }

  const uploadNewBanner = () => {
    const data = new FormData()

    if (document.getElementById('new-banner-img').files.length !== 0) {
      for (let i = 0; i < document.getElementById('new-banner-img').files.length; i++) {
        data.append('file[]', document.getElementById('new-banner-img').files[i])
      }

      data.append('name', '')
      data.append('url', document.getElementById('new-banner-url').value)

      axios.post(API_URL + '/new-banner-home', data, {}).then(
        (res) => {
          setBannersHome(res.data.data)
          handleCloseNewBanner()
        },
        (error) => {
          alert(error)
        }
      )
    } else {
      alert('Seleccione una imagen')
    }
  }

  const deleteBannerHome = (idElement) => {
    const data = {
      name: idElement,
    }

    axios
      .post(API_URL + '/delete-banner-home', data, {
        // receive two parameter endpoint url ,form data
      })
      .then(
        (res) => {
          // then print response status
          setBannersHome(res.data.data)
          handleCloseDeleteBannerHome()
        },
        (error) => {
          alert(error)
        }
      )
  }

  const getBrandsHomeData = () => {
    axios
      .get(API_URL + '/brands-home')
      .then((response) => {
        let brandsHome = response.data.data
        setBrandsHome(brandsHome)
      })
      .catch((error) => console.error('Error: ' + error))
  }

  const uploadNewBrandHome = () => {
    const data = new FormData()

    data.append('id', '')
    data.append('name', '')
    data.append('elementName', document.getElementById('new-brand-home-name').value)

    if (document.getElementById('new-brand-home-img').files.length !== 0) {
      for (let i = 0; i < document.getElementById('new-brand-home-img').files.length; i++) {
        data.append('file[]', document.getElementById('new-brand-home-img').files[i])
      }
      data.append('imgExists', true)
    }

    if (document.getElementById('new-brand-home-logo').files.length !== 0) {
      for (let i = 0; i < document.getElementById('new-brand-home-logo').files.length; i++) {
        data.append('file[]', document.getElementById('new-brand-home-logo').files[i])
      }
      data.append('logoExists', true)
    }

    axios.post(API_URL + '/new-brand-home', data, {}).then(
      (res) => {
        setBrandsHome(res.data.data)
        handleCloseNewBrandHome()
      },
      (error) => {
        alert(error)
      }
    )
  }

  const deleteBrandHome = (idElement) => {
    const data = {
      name: idElement,
    }

    axios.post(API_URL + '/delete-brand-home', data, {}).then(
      (res) => {
        setBrandsHome(res.data.data)
        handleCloseDeleteBrandHome()
      },
      (error) => {
        alert(error)
      }
    )
  }

  const getCategoriasData = () => {
    axios.get(API_URL + '/categorias-home').then((response) => {
      let categoriasHome = response.data.data
      setCategorias(categoriasHome)
    })
  }

  const uploadNewCategoria = () => {
    const data = new FormData()

    data.append('id', '')
    data.append('name', '')
    data.append('elementName', document.getElementById('new-categoria-name').value)

    if (document.getElementById('new-categoria-img').files.length !== 0) {
      for (let i = 0; i < document.getElementById('new-categoria-img').files.length; i++) {
        data.append('file[]', document.getElementById('new-categoria-img').files[i])
      }
    }

    axios.post(API_URL + '/new-categoria-home', data, {}).then(
      (res) => {
        setCategorias(res.data.data)
        handleCloseNewCategoria()
      },
      (error) => {
        alert(error)
      }
    )
  }

  const deleteCategoria = (idElement) => {
    const data = {
      name: idElement,
    }

    axios.post(API_URL + '/delete-categoria-home', data, {}).then(
      (res) => {
        setCategorias(res.data.data)
        handleCloseDeleteCategoria()
      },
      (error) => {
        alert(error)
      }
    )
  }

  const getCatalogoHomeData = () => {
    axios.get(API_URL + '/catalogo-home').then((response) => {
      let catalogosHome = response.data.data
      setCatalogosHome(catalogosHome)
    })
  }

  const getEndbannersHomeData = () => {
    axios
      .get(API_URL + '/endbanners-home')
      .then((response) => {
        let endbannersHome = response.data.data
        setEndbannersHome(endbannersHome)
      })
      .catch((error) => console.error('Error: ' + error))
  }

  const uploadNewEndbanner = () => {
    const data = new FormData()

    if (document.getElementById('new-endbanner-img').files.length !== 0) {
      for (let i = 0; i < document.getElementById('new-endbanner-img').files.length; i++) {
        data.append('file[]', document.getElementById('new-endbanner-img').files[i])
      }

      data.append('name', '')
      data.append('url', document.getElementById('new-endbanner-url').value)

      axios.post(API_URL + '/new-endbanner-home', data, {}).then(
        (res) => {
          setEndbannersHome(res.data.data)
          handleCloseNewEndbanner()
        },
        (error) => {
          alert(error)
        }
      )
    } else {
      alert('Seleccione una imagen')
    }
  }

  const deleteEndbannerHome = (idElement) => {
    const data = {
      name: idElement,
    }

    axios
      .post(API_URL + '/delete-endbanner-home', data, {
        // receive two parameter endpoint url ,form data
      })
      .then(
        (res) => {
          // then print response status
          setEndbannersHome(res.data.data)
          handleCloseDeleteEndbannerHome()
        },
        (error) => {
          alert(error)
        }
      )
  }

  useEffect(() => {
    getBrandsData()
    getBannersHomeData()
    getBrandsHomeData()
    getCategoriasData()
    getCatalogoHomeData()
    getEndbannersHomeData()
  }, [])

  return (
    <div className='row g-5'>
      {/* MARCAS */}
      {/* <div className='col-lg-12'>
        <div className='card card-custom card-stretch shadow mb-5'>
          <div className='card-header'>
            <h3 className='card-title'>Marcas</h3>
            <h5 className='card-subtitle'>El logo debe ser blanco, formato .png</h5>
            <div className='float-end mt-n16'>
              <button className='btn btn-primary fw-bold text-light-dark' onClick={handleShowNewBrand}>
                Agregar
              </button>
            </div>
          </div>
          <div className='card-body'>
            <div className='row'>
              <BrandsItem
                brands={brands}
                setBrands={setBrands}
                deleteBrand={handleShowDeleteBrand}
              />
            </div>
          </div>
          <div className='card-footer d-none'>
            <p className='ms-auto float-end'>
              Las imágenes de los logos deben subirse en formato .png
            </p>
          </div>
        </div>
      </div>

      <Modal show={showNewBrand} onHide={handleCloseNewBrand}>
        <Modal.Header closeButton>
          <Modal.Title>Agregar imagen marca</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='row'>
            <div className='form-group col-md-10'>
              <label>Seleccione imagen:</label>
              <input id='file-marcas-new' type='file' className='form-control' accept='.png' />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type='button' className='btn btn-secondary' onClick={handleCloseNewBrand}>
            Cerrar
          </button>
          <button type='button' className='btn btn-primary' onClick={() => uploadNewBrand()}>
            Guardar
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={showDeleteBrand} onHide={handleCloseDeleteBrand}>
        <Modal.Header closeButton>
          <Modal.Title>Eliminar imagen promoción</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>¿Está seguro que desea eliminar la imagen de promoción?</p>
        </Modal.Body>
        <Modal.Footer>
          <button type='button' className='btn btn-secondary' onClick={handleCloseDeleteBrand}>
            Cerrar
          </button>
          <button
            type='button'
            className='btn btn-danger'
            onClick={() => deleteBrand(deleteBrandId)}
          >
            Eliminar
          </button>
        </Modal.Footer>
      </Modal> */}
      {/* END MARCAS */}

      {/* BANNER HOME */}
      <div className='col-lg-12'>
        <div className='card card-custom card-stretch shadow mb-5'>
          <div className='card-header'>
            <h3 className='card-title mb-2'>Banner principal Home</h3>
            <p>
              <span><b>Dimensiones: </b>1920px de ancho por 800px de alto</span><br />
              <span><b>Peso máximo permitido: </b>600kb</span><br />
              <span><b>Formato: </b>JPG o PNG</span><br />
            </p>
            <div className='float-end mt-n16'>
              <button className='btn btn-primary fw-bold text-light-dark' onClick={handleShowNewBanner}>
                Agregar
              </button>
            </div>
          </div>
          <div className='card-body'>
            <div className='row' id='carousel-concepto'>
              <BannerHomeItem
                bannersHome={bannersHome}
                deleteBannerHome={handleShowDeleteBannerHome}
              />
            </div>
          </div>
          <div className='card-footer d-none'>
            <p className='ms-auto float-end'>
              Las imágenes deben tener una medida de 1920px por 100px y no pesar más de 1MB
            </p>
          </div>
        </div>
      </div>

      <Modal show={showNewBanner} onHide={handleCloseNewBanner}>
        <Modal.Header closeButton>
          <Modal.Title>Agregar Banner</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='row'>
            <div className='form-group col-md-10'>
              <label>URL:</label>
              <input type='text' className='form-control' id='new-banner-url' />
            </div>
            <div className='form-group col-md-10'>
              <label>Seleccione imagen:</label>
              <input id='new-banner-img' type='file' className='form-control' accept='image/*' />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type='button' className='btn btn-secondary' onClick={handleCloseNewBanner}>
            Cerrar
          </button>
          <button type='button' className='btn btn-primary' onClick={() => uploadNewBanner()}>
            Guardar
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={showDeleteBannerHome} onHide={handleCloseDeleteBannerHome}>
        <Modal.Header closeButton>
          <Modal.Title>Eliminar Banner Home</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>¿Está seguro que desea eliminar el banner?</p>
        </Modal.Body>
        <Modal.Footer>
          <button type='button' className='btn btn-secondary' onClick={handleCloseDeleteBannerHome}>
            Cerrar
          </button>
          <button
            type='button'
            className='btn btn-danger'
            onClick={() => deleteBannerHome(deleteBannerHomeId)}
          >
            Eliminar
          </button>
        </Modal.Footer>
      </Modal>
      {/* END BANNER HOME */}

      {/* MARCAS HOME */}
      {/* <div className='col-lg-12'>
        <div className='card card-custom card-stretch shadow mb-5 marcas-home'>
          <div className='card-header'>
            <h3 className='card-title'>Imagen principal Marcas</h3>
            <h5 className='card-subtitle'>
              La imagen principal de la marca ya debe tener el logo encima
            </h5>
            <h5 className='card-subtitle'>El logo debe ser en blanco y png</h5>
            <div className='form-group float-end'>
              <button
                type='submit'
                className='btn btn-primary fw-bold text-light-dark mt-n20 mb-10'
                onClick={handleShowNewBrandHome}
              >
                Agregar
              </button>
            </div>
          </div>

          <div className='card-body'>
            <div className='row'>
              <BrandsHomeItem brandsHome={brandsHome} deleteBrandHome={handleShowDeleteBrandHome} />
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={showNewBrandHome}
        onHide={handleCloseNewBrandHome}
        className='modal-new-brand-home'
      >
        <Modal.Header closeButton>
          <Modal.Title>Agregar Marca en Home</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='form-group col-md-10 mb-2'>
            <label>Nombre:</label>
            <input type='text' className='form-control' id='new-brand-home-name' />
          </div>
          <div className='form-group col-md-10 mb-2'>
            <label>Imagen principal:</label>
            <input type='file' className='form-control' accept='image/*' id='new-brand-home-img' />
          </div>
          <div className='form-group col-md-10 mb-2'>
            <label>Logo:</label>
            <input type='file' className='form-control' accept='.png' id='new-brand-home-logo' />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type='button' className='btn btn-secondary' onClick={handleCloseNewBrandHome}>
            Cerrar
          </button>
          <button type='button' className='btn btn-primary' onClick={() => uploadNewBrandHome()}>
            Guardar
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showDeleteBrandHome}
        onHide={handleCloseDeleteBrandHome}
        className='moda-delete-brand-home'
      >
        <Modal.Header closeButton>
          <Modal.Title>Eliminar marca home</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>¿Seguro que desea eliminar la marca?</p>
          <p>Esta acción no puede deshacerse</p>
        </Modal.Body>
        <Modal.Footer>
          <button type='button' className='btn btn-secondary' onClick={handleCloseDeleteBrandHome}>
            Cerrar
          </button>
          <button
            type='button'
            className='btn btn-danger'
            onClick={() => deleteBrandHome(deleteBrandHomeId)}
          >
            Eliminar
          </button>
        </Modal.Footer>
      </Modal> */}
      {/* END MARCAS HOME */}

      {/* CATEGORIAS HOME */}
      <div className='col-lg-12'>
        <div className='card card-custom card-stretch shadow mb-5 home-categorias'>
          <div className='card-header'>
            <h3 className='card-title'>Categorías</h3>
            <p>
              El orden en el que se muestran es el orden para el carrusel y el sidebar del catálogo.<br /><br />

              <b>Dimensiones:</b> 900 de ancho por 1000 de alto (o proporcional)<br />
              <b>Peso máximo permitido:</b> 600kb<br />
              <b>Formato:</b> PNG con transparencia<br />
            </p>
            <div className='form-group float-end'>
              <button
                type='submit'
                className='btn btn-primary fw-bold text-light-dark mt-n20 mb-10'
                onClick={handleShowNewCategoria}
              >
                Agregar
              </button>
            </div>
          </div>
          <div className='card-body'>
            <div className='row'>
              <CategoriasItem categorias={categorias} deleteCategoria={handleShowDeleteCategoria} />
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={showNewCategoria}
        onHide={handleCloseNewCategoria}
        className='modal-new-categoria'
      >
        <Modal.Header closeButton>
          <Modal.Title>Agregar Categoría</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='form-group col-md-10 mb-2'>
            <label>Nombre:</label>
            <input type='text' className='form-control' id='new-categoria-name' />
          </div>
          <div className='form-group col-md-10 mb-2'>
            <label>Imagen principal:</label>
            <input type='file' className='form-control' accept='image/*' id='new-categoria-img' />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type='button' className='btn btn-secondary' onClick={handleCloseNewCategoria}>
            Cerrar
          </button>
          <button type='button' className='btn btn-primary' onClick={() => uploadNewCategoria()}>
            Guardar
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={showDeleteCategoria} onHide={handleCloseDeleteCategoria}>
        <Modal.Header closeButton>
          <Modal.Title>Eliminar Categoría</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>¿Está seguro que desea eliminar la categoría?</p>
        </Modal.Body>
        <Modal.Footer>
          <button type='button' className='btn btn-secondary' onClick={handleCloseDeleteCategoria}>
            Cerrar
          </button>
          <button
            type='button'
            className='btn btn-danger'
            onClick={() => deleteCategoria(deleteCategoriaId)}
          >
            Eliminar
          </button>
        </Modal.Footer>
      </Modal>
      {/* END CATEGORIAS HOME */}

      {/* MID Banner */}
      <MidBanner />
      {/* END MID BANNER */}

      {/* HOME CATALOGO */}
      <div className='col-lg-12'>
        <div className='card card-custom card-stretch shadow mb-5 home-categorias'>
          <div className='card-header'>
            <h3 className='card-title'>Imágenes Carrusel productos Home</h3>
            <p>
              Las imágenes deben tener el fondo incluido (no transparentes)<br/><br/>
              <span><b>Dimensiones: </b>900 de ancho por 1000 de alto (o proporcional)</span><br />
              <span><b>Peso máximo permitido: </b>600kb</span><br />
              <span><b>Formato: </b>JPG o PNG SIN transparencia</span><br />
            </p>
          </div>
          <div className='card-body'>
            <div className='row d-flex flex-center flew-grow-1'>
              <CatalogosHomeItem catalogosHome={catalogosHome} />
            </div>
          </div>
        </div>
      </div>
      {/* END HOME CATALOGO */}

      {/* ENDBANNER HOME */}
      <div className='col-lg-12'>
        <div className='card card-custom card-stretch shadow mb-5'>
          <div className='card-header'>
            <h3 className='card-title'>Carrusel promociones</h3><p>
              <span><b>Dimensiones: </b>1920px de ancho por 800px de alto</span><br />
              <span><b>Peso máximo permitido: </b>600kb</span><br />
              <span><b>Formato: </b>JPG o PNG</span><br />
            </p>
            <div className='float-end mt-n16'>
              <button className='btn btn-primary' onClick={handleShowNewEndbanner}>
                Agregar
              </button>
            </div>
          </div>
          <div className='card-body'>
            <div className='row' id='carousel-concepto'>
              <EndbannerHomeItem
                endbannersHome={endbannersHome}
                deleteEndbannerHome={handleShowDeleteEndbannerHome}
              />
            </div>
          </div>
          <div className='card-footer d-none'>
            <p className='ms-auto float-end'>
              Las imágenes deben tener una medida de 1920px por 100px y no pesar más de 1MB
            </p>
          </div>
        </div>
      </div>

      <Modal show={showNewEndbanner} onHide={handleCloseNewEndbanner}>
        <Modal.Header closeButton>
          <Modal.Title>Agregar Endbanner</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='row'>
            <div className='form-group col-md-10'>
              <label>URL:</label>
              <input type='text' className='form-control' id='new-endbanner-url' />
            </div>
            <div className='form-group col-md-10'>
              <label>Seleccione imagen:</label>
              <input id='new-endbanner-img' type='file' className='form-control' accept='image/*' />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type='button' className='btn btn-secondary' onClick={handleCloseNewEndbanner}>
            Cerrar
          </button>
          <button type='button' className='btn btn-primary' onClick={() => uploadNewEndbanner()}>
            Guardar
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={showDeleteEndbannerHome} onHide={handleCloseDeleteEndbannerHome}>
        <Modal.Header closeButton>
          <Modal.Title>Eliminar Endbanner Home</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>¿Está seguro que desea eliminar el banner?</p>
        </Modal.Body>
        <Modal.Footer>
          <button type='button' className='btn btn-secondary' onClick={handleCloseDeleteEndbannerHome}>
            Cerrar
          </button>
          <button
            type='button'
            className='btn btn-danger'
            onClick={() => deleteEndbannerHome(deleteEndbannerHomeId)}
          >
            Eliminar
          </button>
        </Modal.Footer>
      </Modal>
      {/* END BANNER HOME */}
    </div>
  )
}

export {HomePage}
